export const visitTone = (days) => {
  if (days === 999 || days == null) return "red";
  if (days > 90) return "red";
  if (days > 45) return "orange";
  if (days > 21) return "amber";
  return "green";
};

export const visitLabel = (days) => {
  if (days === 999 || days == null) return "Sin visitas";
  if (days > 90) return "Urgente";
  if (days > 45) return "Descuidado";
  if (days > 21) return "Atención";
  return `Hace ${days}d`;
};
